import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { finalize, map, take } from 'rxjs/operators';
import * as moment from 'moment';
import { OrgStaffUserInterface, OrgStaffUserInterfaceWithId } from '@sk/sk-interfaces';
import { LocalStorageService } from 'services/local-storage.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { fromPromise } from 'rxjs/internal-compatibility';

@Injectable({
  providedIn: 'root'
})
export class StaffService {

  constructor(private firestoreService: AngularFirestore,
              private storageService: LocalStorageService,
              private http: HttpClient) {
  }

  /**
   * Resend invitation email
   * @param organizationUid
   */
  resendStaffInvite(organizationUid:string) {

    if (!organizationUid) {
      throwError(new Error('Invalid OrganizationUid'));
    }

    const payload = {
      organizationUid: organizationUid
    };
    return this.http
      .post(environment.api_url + '/resendUserInvitation', payload)
      .pipe(
        take(1)
      );
  }


  /**
   * Revoke pending invitation and make user inactive
   * @param organizationUid
   */
  revokeStaffInvite(organizationUid) {

    if (!organizationUid) {
      throwError(new Error('Invalid OrganizationUid'));
    }

    const payload = {
      organizationUid: organizationUid
    };
    return this.http
      .post(environment.api_url + '/revokeUserInvitation', payload)
      .pipe(
        take(1)
      );
  }


  queryStateChangesStaff() {
    console.log(`RUN STAFF QUERY - ${moment().format('HH:mm:ss')}`);
    const organizationId = this.storageService.getStorage('organizationId');
    return this.firestoreService.collection('organizations').doc(organizationId)
      .collection<OrgStaffUserInterface>('users',
        ref => ref.where('type', '==', 'staff')
      )
      .stateChanges()
      .pipe(
        finalize(() => console.log('STAFF QUERY DONE'))
      )
  }


  /**
   *
   * @param formValue
   */
  addStaff(staff: OrgStaffUserInterfaceWithId): Observable<OrgStaffUserInterfaceWithId> {

    const currentStaff = {
      ...staff
    };
    if (currentStaff.type !== 'staff') {
      throw new Error('Not a staff member');
      return;
    }

    if (currentStaff.id !== undefined) {
      delete currentStaff.id;
    }
    if (currentStaff.exists !== undefined) {
      delete currentStaff.exists;
    }

    const organizationId = this.storageService.getOrganizationId();
    return fromPromise(this.firestoreService.collection('organizations').doc(organizationId)
      .collection('users').add(staff))
      .pipe(
        map(res => {
          const id = res.id;
          const exists = true;
          return { ...staff, id, exists } as OrgStaffUserInterfaceWithId;
        }));
  }


  /**
   *
   * @param formValue
   * @param id
   */
  updateStaffWithId(staff: OrgStaffUserInterfaceWithId, id: string): Observable<OrgStaffUserInterfaceWithId> {
    // Convert Staff object to a new Staff Object to bypass frozen state of NGRX
    const currentStaff = {
      ...staff
    };
    if (currentStaff.type !== 'staff') {
      throw new Error('Not a staff member');
      return;
    }

    if (currentStaff.id !== undefined) {
      delete currentStaff.id;
    }
    if (currentStaff.exists !== undefined) {
      delete currentStaff.exists;
    }

    const organizationId = this.storageService.getOrganizationId();
    return fromPromise(this.firestoreService
      .collection('organizations').doc(organizationId)
      .collection('users').doc(id).update(currentStaff))
      .pipe(
        map(() => {
          const exists = true;
          return { ...staff, id, exists } as OrgStaffUserInterfaceWithId;
        }));
  }


}

